<template>
  <div>
    <div class="calculator-totals df fdc" v-if="$store.getters.showCalculator">
      <div class="pricing-row pricing-row-1 pricing-row-0 title-row df fdr jcsb aic comments-title-row">
        <p class="comments-title">Calculator</p>
      </div>
      <Calculator ref="calculatorRef" v-bind:calculatorKeyPress="calculatorKeyPress"/>
    </div>
    <div class="hours-totals df fdc" v-if="$store.getters.showPricesHours" v-bind:class="{'hours-totals-only': !$store.getters.showPricesPrices}">
      <div class="pricing-row pricing-row-1 pricing-row-0">
      </div>
      <div class="pricing-row pricing-row-1 pricing-row-0 title-row">
        <div class="section">Hours</div>
      </div>
    </div>
    <div class="prices-totals df fdc" v-if="$store.getters.showPricesPrices">
      <div class="pricing-row pricing-row-1 pricing-row-0">
      </div>
      <div class="pricing-row pricing-row-1 pricing-row-0 title-row">
        <div class="section">Prices</div>
      </div>
    </div>
    <div class="comments-totals df fdc" v-if="$store.getters.showPricesComments">
      <div class="pricing-row pricing-row-1 pricing-row-0 title-row df fdr jcsb aic comments-title-row">
        <p class="comments-title">Comments</p>
        <p v-if="!addingComment && (($store.getters.tokenData.type == 'comment') || (!$store.getters.tokenData.type))" class="full-blue" v-on:click="startAddingNewComment()">
          <img src="/images/plus-full.png" class="small-icon" alt="">
        </p>
      </div>
      <div class="comment-list df fdc">
        <span class="comments-filter df">
          <p class="unresolved" v-bind:class="{'semi-bold': resolvedComments}" v-on:click="toggleResolvedComments()">
            Unresolved
          </p>
          <p class="resolved" v-bind:class="{'semi-bold': !resolvedComments}" v-on:click="toggleResolvedComments()">
            Resolved
          </p>
        </span>
        <textarea ref="commentBox" @focus="commentBoxActive = true" @blur="commentBoxActive = false" v-if="addingComment" v-model="addingCommentText" placeholder="Type Something..." class="box adding-comment-text" name="" id="" cols="30" rows="10"/>
        <span class="comment-buttons-wrap df jcfe">
          <button v-on:click="stopAddingNewComment()" class="add button-x button-x-grey cancel-add-comment" v-if="addingComment" v-bind:class="{'button-form-active': addingCommentText !== ''}">Cancel</button>
          <button v-on:click="addTheComment()" class="add button-x" v-if="addingComment" v-bind:class="{'button-form-active': addingCommentText !== ''}">Add</button>
        </span>
        <span v-if="(!resolvedComments && (comment.status == 'resolved')) || (resolvedComments && (comment.status == 'active'))" v-for="(comment, i) in sortedByDate($store.getters.currentProjectComments)" class="one-comment box df fdr" v-bind:class="{'comment-resolved': comment.status == 'resolved'}">
          <span class="comments-initials-single comments-initials-single-active mr12">
            {{comment.initials}}
          </span>
          <span class="one-comment-right f1 df fdc">
            <p class="comment-date">{{ formatCommentDate(comment.time) }}</p>
            <p>{{comment.text}}</p>
            <p v-if="(comment.status == 'active') && (!$store.getters.tokenData.type)" v-on:click="resolveComment(comment.id)" class="resolve-comment curp">Resolve</p>
            <p v-else-if="(!$store.getters.tokenData.type)" v-on:click="reopenComment(comment.id)" class="resolve-comment">Re-Open</p>
          </span>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import Calculator from '../../elements/Calculator'
import { mapGetters } from 'vuex'

export default {
  name: "PricingTopActionWrapper",
  components: {
    Calculator,
  },
  data() {
    return {
      addingComment: false,
      addingCommentText: '',
      resolvedComments: true
    };
  },
  methods: {
    toggleResolvedComments () {
      this.resolvedComments = !this.resolvedComments
    },
    reopenComment (id) {
      var data = {
        projectid: this.$route.params.projectid,
        commentid: id
      }
      this.$store.dispatch('reopenComment', data).then(() => {
        console.log('after reopenComment')
      })
    },
    resolveComment (id) {
      var data = {
        projectid: this.$route.params.projectid,
        commentid: id
      }
      this.$store.dispatch('resolveComment', data).then(() => {
        console.log('after resolveComment')
      })
    },
    addTheComment () {
      if (this.addingCommentText !== '') {
        var date = new Date()
        date = date.getTime()
        console.log('comment........', this.$store.getters.tokenData)
        var name = this.$store.getters.userData.fullName || this.$store.getters.tokenData.email
        var initials = name.match(/\b\w/g) || [];
        initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();

        var comment = {
          text: this.addingCommentText,
          time: date,
          uid: this.$store.getters.uid || null,
          token: this.$store.getters.tokenData.id || null,
          status: 'active',
          initials
        }
        var data = {
          projectid: this.$route.params.projectid,
          comment
        }
        if (this.$store.getters.tokenData.email) {
          console.log('adding comment from token');
          this.$store.dispatch('addTheCommentFromToken', data).then(() => {
            console.log('after addTheCommentFromToken')
            this.addingComment = false
            this.addingCommentText = ''
          })
        } else {
          this.$store.dispatch('addTheComment', data).then(() => {
            console.log('after addTheComment')
            this.addingComment = false
            this.addingCommentText = ''
          })
        }
      }
    },
    startAddingNewComment () {
      this.addingComment = true
      this.$nextTick(() => this.$refs.commentBox.focus())
      // this.addingCommentText = ''
    },
    stopAddingNewComment () {
      this.addingComment = false
      // this.addingCommentText = ''
    },
    sortedByDate (arr) {
      console.log('arr', arr)
      console.log('1 array...', array)
      var array = []
      for (var item in arr) {
        var _item = {...arr[item], id: item}
        array.push(_item)
      }
      console.log('array...', array)
      array.sort(function(a, b){
        return b.time - a.time
      });
      console.log('2 array...', array)
      return array
    },
    calculatorKeyPress (button) {
      console.log('press calculator button', button)
       this.$refs.calculatorRef.pressKey(button);
    },
    handleKeyStrokes () { // registers keystrokes and initiates action from key
      const _this = this
      document.onkeydown = checkKey
      function checkKey(e) {
        e = e || window.event;
        if (_this.$store.getters.showCalculator) {
          _this.calculatorKeyPress(e.keyCode)
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'userRole'
    ]),
    copyLink() {
      return window.location + `?token=${this.token}`;
    },
    editable() {
      return ['admin', 'collaborator', 'vendor'].includes(this.userRole)
    }
  },
  created () {
    this.handleKeyStrokes();
  }
}
</script>
<style scoped lang="scss">
@import "../../../styles/components/_pricingpage.scss";
</style>
